import { useRoutes } from 'react-router-dom';
import { useAuth } from '@/lib/auth';
import { useFeatureFlagEnabled } from 'posthog-js/react';
import { protectedRoutes } from './protected';
import { publicRoutes, commonRoutes } from './public';
import _ from 'lodash';

export const AppRoutes = () => {
  const { user } = useAuth();
  const isDeepDivesEnabled = useFeatureFlagEnabled('deep-dives');
  const isPetaReportsEnabled = useFeatureFlagEnabled('peta-reports');
  const isTemplatesEnabled = useFeatureFlagEnabled('templates');
  const isSettingsIntegrationsEnabled = useFeatureFlagEnabled(
    'settings-integrations'
  );

  const posthogFlags = {
    'deep-dives': isDeepDivesEnabled,
    'peta-reports': isPetaReportsEnabled,
    templates: isTemplatesEnabled,
    'settings-integrations': isSettingsIntegrationsEnabled,
  };

  const getAuthorizedRoutes = () => {
    const authorizedRoutes = _.cloneDeep(protectedRoutes);
    return authorizedRoutes.filter((route) => {
      if (user) {
        if (route.children) {
          route.children = route.children.filter((childRoute) => {
            if (!childRoute.role) {
              // enable route for all user roles
              if (typeof posthogFlags[childRoute.posthogFlag] === 'boolean') {
                // if posthog present, decide based on flag
                return posthogFlags[childRoute.posthogFlag];
              } else {
                return true;
              }
            } else {
              // enable route based on user roles
              if (typeof posthogFlags[childRoute.posthogFlag] === 'boolean') {
                // if posthog present, decide based on flag and user role
                return (
                  posthogFlags[childRoute.posthogFlag] &&
                  user.role?.toLowerCase() === childRoute.role
                );
              } else {
                // if not posthog present, disable based on user role
                return user.role?.toLowerCase() === childRoute.role;
              }
            }
          });
        }

        return route;
      }
    });
  };

  const routes = !user ? publicRoutes : getAuthorizedRoutes();

  const element = useRoutes([...routes, ...commonRoutes]);

  return <>{element}</>;
};
